// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__1Z8Lp","ball1":"Spinner_ball1__1uMF2","ball2":"Spinner_ball2__3TdJE","sk-bounce":"Spinner_sk-bounce__1TItc"};